import { BEMBlock } from 'helpers/classnames';
import * as React from 'react';
import './styles/Breadcrumb.scss';

interface BreadcrumbProps {
    className: string;
    children: React.ReactNode;
}

const Breadcrumb = React.forwardRef(({
    className, children,
}: BreadcrumbProps, ref:React.Ref<HTMLElement>) => {
    const [, BEMElement] = BEMBlock('palette-breadcrumb');

    return (
        <nav
            ref={ref}
            aria-label="breadcrumb"
            className={className}
        >
            <ol className={BEMElement('list')}>
                { children }
            </ol>
        </nav>
    );
});

Breadcrumb.displayName = 'Breadcrumb';

export default Breadcrumb;
